import { Link } from "react-router-dom";
import { MessageCircle, Instagram, Phone, MapPin } from "lucide-react";
import { NAV, WA_DEFAULT, INSTAGRAM_URL, PHONE_DISPLAY, PHONE_TEL, SERVICES, serviceHref, ADDRESS, MAP_URL } from "@/lib/site";

const Col = ({ title, children }) => (
  <div>
    <p className="mb-5 text-xs font-semibold uppercase tracking-[0.25em] text-neutral-500">{title}</p>
    <ul className="space-y-3">{children}</ul>
  </div>
);
const item = "text-sm text-neutral-300 transition-colors hover:text-white";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-black">
    <div className="mx-auto max-w-7xl px-5 py-16 md:px-8">
      <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1.2fr]">
        <div>
          <span className="logo-shine" style={{ "--logo-mask": "url(/fx-logo-dark.png)" }}><img src="/fx-logo-dark.png" alt="FX Motors logosu" className="h-9 w-auto md:h-11" /></span>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-neutral-400">FX Motor Sporları — Sancaktepe Motosiklet Spor Kulübü. Kendi parkurumuz ve doğası var; motor ve ekipman bizden.</p>
        </div>
        <Col title="Eğitim & Tur">
          {SERVICES.map((s) => <li key={s.key}><Link to={serviceHref(s.key)} data-testid={`footer-service-${s.key}`} className={item}>{s.title}</Link></li>)}
        </Col>
        <Col title="Kulüp">
          {NAV.filter((n) => !n.children && n.to !== "/" && n.to !== "/enduro-tur").map((n) => <li key={n.to}><Link to={n.to} data-testid={`footer-nav-${n.to.slice(1)}`} className={item}>{n.label}</Link></li>)}
          <li><Link to="/rezervasyon" data-testid="footer-nav-rezervasyon" className={item}>Rezervasyon</Link></li>
        </Col>
        <Col title="İletişim">
          <li><a href={WA_DEFAULT} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link" className={`${item} flex items-center gap-2`}><MessageCircle className="h-4 w-4 text-brand" /> WhatsApp: {PHONE_DISPLAY}</a></li>
          <li><a href={PHONE_TEL} data-testid="footer-phone-link" className={`${item} flex items-center gap-2`}><Phone className="h-4 w-4 text-brand" /> {PHONE_DISPLAY}</a></li>
          <li><a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link" className={`${item} flex items-center gap-2`}><Instagram className="h-4 w-4 text-brand" /> @fxmotorsporlari</a></li>
          <li><a href={MAP_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-address-link" className={`${item} flex items-start gap-2`}><MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand" /> {ADDRESS}</a></li>
        </Col>
      </div>
      <div className="mt-14 border-t border-white/10 pt-8 text-xs text-neutral-600">© {new Date().getFullYear()} FX Motor Sporları</div>
    </div>
  </footer>
);

export const WhatsAppFloat = () => (
  <a href={WA_DEFAULT} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp'tan yaz" data-testid="whatsapp-float-btn" className="fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center bg-[#25D366] text-black shadow-[4px_4px_0_0_#D90000] transition-transform hover:-translate-y-1">
    <MessageCircle className="h-7 w-7" />
  </a>
);
